import { render, staticRenderFns } from "./HistorialEmergencia.vue?vue&type=template&id=7ecda990"
import script from "./HistorialEmergencia.vue?vue&type=script&lang=js"
export * from "./HistorialEmergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports